// Waits before asking for the file: the server refuses tokens used too quickly (bots rush)
const TOKEN_DELAY_MS = 1600;

// The PDF is served by the server (server/notify.js) only with a short-lived token,
// it is never exposed as a public file. The server also alerts the Discord webhook.
export async function fetchManuscript() {
  const tokenResponse = await fetch('/api/manuscript/token', { method: 'POST' });
  if (!tokenResponse.ok) throw new Error('Access denied');
  const { token } = await tokenResponse.json();
  await new Promise(resolve => setTimeout(resolve, TOKEN_DELAY_MS));
  const fileResponse = await fetch('/api/manuscript/file', { headers: { 'X-Manuscript-Token': token } });
  if (!fileResponse.ok) throw new Error('Access denied');
  return fileResponse.blob();
}

// Saved as a generic binary file: otherwise Firefox tries to open the downloaded PDF
// from file:/// and blocks it with a security error
export function downloadFile(blob, fileName) {
  const url = URL.createObjectURL(new Blob([blob], { type: 'application/octet-stream' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 10000);
}
